import { useLocation } from 'react-router-dom'
import { Lockup } from '@/components/brand/Brand'
import { needsConsent, reviewConsent } from '@/components/consent/consent'
import { hasMotion, sectionLinks } from '@/components/layout/navigation'
import { useMotion } from '@/components/motion/motion'
import { SiteLink } from '@/components/ui/SiteLink'
import { sitePages } from '@/config/pages'

export const SiteFooter = () => {
  const { pathname } = useLocation()
  const links = sectionLinks(pathname)
  const { paused, setPaused } = useMotion()

  return (
    <footer className="footer wrap">
      <div className="footer-brand">
        <Lockup />
      </div>
      <nav className="footer-links" aria-label="Footer">
        <SiteLink to={sitePages.howItWorks.path}>How it works</SiteLink>
        <SiteLink to={sitePages.about.path}>About</SiteLink>
        <SiteLink to={sitePages.faq.path}>FAQ</SiteLink>
        {links.teamInFooter ? <SiteLink to={links.team}>Team</SiteLink> : null}
        <SiteLink to={sitePages.manifesto.path}>Manifesto</SiteLink>
        <SiteLink to={links.contact}>Contact</SiteLink>
        {hasMotion(pathname) ? (
          <button type="button" className="footer-motion" aria-pressed={paused} onClick={() => setPaused(!paused)}>
            {paused ? 'Play motion' : 'Pause motion'}
          </button>
        ) : null}
      </nav>
      <div className="footer-legal">
        {/* The year comes from the visitor's clock, so it may differ from the year the page was built. */}
        <p suppressHydrationWarning>All Rights Reserved, © {new Date().getFullYear()}</p>
        <p className="footer-disclaimer">
          United Accountants (“UA”) is not a licensed CPA firm. Its subsidiary entities, which are not licensed CPA firms, provide
          tax, advisory, and other non-attest services to clients. United Accountants Firms practice in an alternative practice
          structure in accordance with the AICPA Code of Professional Conduct and applicable law, regulations, and professional
          standards. UA does not provide services to clients.
        </p>
        <div className="footer-policies">
          <SiteLink to={sitePages.privacy.path}>Privacy policy</SiteLink>
          {needsConsent ? (
            <button type="button" className="footer-motion" onClick={reviewConsent}>
              Cookie settings
            </button>
          ) : null}
        </div>
      </div>
    </footer>
  )
}
